// biome-ignore lint/suspicious/noEmptyBlockStatements: allow
export function noop(): void {}
